export default __webpack_public_path__ + "static/media/egg-crack.582cae05.mp3";